import { render, staticRenderFns } from "./transmodel.vue?vue&type=template&id=f3432e26&scoped=true&"
import script from "./transmodel.vue?vue&type=script&lang=js&"
export * from "./transmodel.vue?vue&type=script&lang=js&"
import style0 from "./transmodel.vue?vue&type=style&index=0&id=f3432e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3432e26",
  null
  
)

export default component.exports